import { sortBy } from 'lodash-es';

import { hasValue } from '.';
import { RecordType } from '../..';
import { RecordPropertyForDisplay } from './RecordProperty';

export const useRemainingFields = (
  parsedFields: RecordType,
  showEmpty: boolean
) => {
  const fields: RecordPropertyForDisplay[] = sortBy(
    Object.entries(parsedFields),
    ([name]) => name
  ).map(([name, value]) => ({
    name,
    value,
  }));

  if (showEmpty) {
    return fields;
  }

  return fields.filter(({ value }) => hasValue(value));
};
